import {ComponentPropsFromRoute} from "../../../../../routers/routers";
import React, {useState} from "react";
import {useRequiredStore} from "../../../../../utils/store";
import {AgentDataStoreContext} from "../../agent.data.store";
import {Alert, Button, Form, Radio, Space, Typography} from "antd";
import {useForm} from "antd/lib/form/Form";
import {useTranslate} from "../../../../../hooks/translate.hook";
import {AgentDataInvoicesNewInvoicesTable} from "../new/invoices-table/agent.data.invoices.new.invoices-table";
import {
    AgentDataInvoicesNewMergedInvoicesTable
} from "../new/merged-invoices-table/agent.data.invoices.new.merged-invoices-table";
import {mergedInvoiceService} from "../../../../../services/documents/invoices/merged.invoices.service";
import {useNavigate} from "react-router";

interface AgentDataMergedInvoicesProps extends ComponentPropsFromRoute {
}

export const AgentDataMergedInvoicesNew: React.FC<AgentDataMergedInvoicesProps> = () => {

    const t = useTranslate();
    const navigate = useNavigate();

    const [loading, setLoading] = useState<boolean>(false);

    const { account } = useRequiredStore(AgentDataStoreContext);

    const [ form ] = useForm();

    const create = () => {
        form.submit();
    }

    return (
        <>
            <Typography.Title level={3} style={{marginTop: 15}}>
                {t("New invoice document")}
            </Typography.Title>

            <Alert
                style={{marginBottom: 20}}
                message={<>
                    {t("PAYMENT_TERMS")}: <b>{account?.paymentTerms || '-'}</b>
                    <br />
                    {t("SHIPMENT_CONDITION")}: <b>{account?.shipmentCondition || '-'}</b>
                </>}
                type="warning"
            />

            <Form
                form={form}
                layout="vertical"
                name={"integrations_form"}
                initialValues={{type: "new"}}
                onFinish={() =>
                    form.validateFields().then(async (values) => {
                        setLoading(true);
                        try {
                            const document = await mergedInvoiceService.createInvoice(values);
                            navigate("/merged-invoices/" + document.id);
                        } catch (e) {
                            setLoading(false)
                        }
                    })
                }>

                <Form.Item
                    label="Action type"
                    name="type"
                    rules={[{ required: true, message: t("FROM.ERROR.PLEASE_SELECT_VALUE") }]}
                >
                    <Radio.Group disabled={loading}>
                        <Radio.Button value="new">Create a new invoice document</Radio.Button>
                        <Radio.Button value="exists">Add to exists invoice document</Radio.Button>
                    </Radio.Group>
                </Form.Item>

                <Form.Item
                    shouldUpdate={(p, n) => p.type !== n.type}
                    noStyle
                >
                    {() => (
                        <>
                            {form.getFieldValue('type') === 'exists' ? (
                                <Form.Item
                                    name="mergedInvoice"
                                    label={t("Invoice documents")}
                                    rules={[{ required: true, message: t("FROM.ERROR.PLEASE_SELECT_VALUE") }]}
                                >
                                    <AgentDataInvoicesNewMergedInvoicesTable accountId={account!.id} multiple={false} />
                                </Form.Item>
                            ) : null}
                        </>
                    )}
                </Form.Item>

                <Form.Item
                    name="documents"
                    label={t("DOCUMENTS.TITLE")}
                    rules={[{ required: true, message: t("FROM.ERROR.PLEASE_SELECT_VALUE") }]}
                >
                    <AgentDataInvoicesNewInvoicesTable
                        accountId={account!.id}
                        multiple={true}
                        type={"pre-closed"}
                    />
                </Form.Item>

                <Form.Item shouldUpdate>
                    {() => (
                        <>
                            {form.getFieldValue('type') === 'new' ? (
                                <Space direction={"horizontal"}>
                                    <Button
                                        disabled={loading}
                                        onClick={create}
                                    >{t("CREATE")}</Button>
                                </Space>
                            ) : (
                                <Space direction={"horizontal"}>
                                    <Button
                                        disabled={loading}
                                        type={"primary"}
                                        onClick={create}
                                    >Add to invoice document</Button>
                                </Space>
                            )}
                        </>
                    )}
                </Form.Item>
            </Form>
        </>
    )
}